import React, {useMemo, useState, useEffect} from "react";
import styled from "styled-components";
import {Field} from "react-final-form";
import {TipSectionHeader} from "../../checkout/components/components";
import {formatPrice} from "src/core/common/price";

function OrderTipField({order}) {
  const {totalPrice} = useMemo(() => (order ? order.getPrices() : {}), [order]);

  const prices = useMemo(() => {
    let tempPrices = [];
    if (totalPrice) {
      for (let i = 1; i <= 4; i++) {
        const percent = Math.round(0.05 * i * 100);
        tempPrices.push({
          ...totalPrice,
          amount: Math.round(totalPrice.amount * 0.05 * i),
          percentLabel: `${percent}%`,
          percent: percent,
        });
      }
    }
    return tempPrices;
  }, [totalPrice]);

  const [custom, setCustom] = useState(false);
  const [customValue, setCustomValue] = useState(0);

  useEffect(() => {
    if (totalPrice) {
      setCustomValue(
        formatPrice({...totalPrice, amount: 0}, {includeFractionDigits: true})
      );
    }
  }, [totalPrice]);

  function selectTip(onChange, value, isCustom) {
    setCustom(isCustom);
    if (isCustom) {
      let absoluteValue = value.replace(/[^0-9]/g, "");

      setCustomValue(
        formatPrice({...totalPrice, amount: absoluteValue}, {includeFractionDigits: true})
      );
      onChange({amount: absoluteValue});
    } else {
      onChange(value);
    }
  }

  function isSelected(input, price) {
    return input.value && input.value.amount === price.amount && !custom;
  }

  return (
    <>
      <TipSectionHeader
        title="Show support with a tip"
        subtitle={`Your order was ${formatPrice(totalPrice)}`}
      />
      {prices.length > 0 && (
        <Field
          name={"tip"}
          initialValue={prices[0]}
          render={({input}) => (
            <HorizontalRadio>
              {prices.map((price, index) => (
                <RadioButton
                  key={`radio-button-${index}`}
                  type="button"
                  selected={isSelected(input, price)}
                  onClick={() => selectTip(input.onChange, price)}
                >
                  <PercentText>{price.percentLabel}</PercentText>
                  <ValueText selected={isSelected(input, price)}>
                    {formatPrice(price)}
                  </ValueText>
                </RadioButton>
              ))}
              <RadioInput
                value={customValue}
                selected={custom}
                onFocus={e => e.target.select()}
                onClick={() => selectTip(input.onChange, customValue, true)}
                onChange={event => selectTip(input.onChange, event.target.value, true)}
              />
            </HorizontalRadio>
          )}
        />
      )}
    </>
  );
}

const HorizontalRadio = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 371px;
`;

const RadioButton = styled.button`
  background: ${({selected, theme}) =>
    selected ? theme.v2.color.primary : theme.v2.color.base.grey["50"]};
  color: ${({selected, theme}) =>
    selected ? theme.v2.color.base.grey["50"] : theme.v2.color.primary};
  border: 1px solid #ebebeb;
  box-sizing: border-box;
  border-radius: ${({theme}) => theme.v2.decoration.border.radius.default};
  height: 50px;
  width: 45px;
`;

const RadioInput = styled.input`
  height: 50px;
  width: 80px;
  border: 1px solid #ebebeb;
  background: ${({selected, theme}) =>
    selected ? theme.v2.color.primary : theme.v2.color.base.grey["50"]};
  color: ${({selected, theme}) =>
    selected ? theme.v2.color.base.grey["50"] : theme.v2.color.base.grey["600"]};
  box-sizing: border-box;
  border-radius: ${({theme}) => theme.v2.decoration.border.radius.default};
  text-align: center;
  font-family: ${({theme}) => theme.v2.typography.bodyText1.family};
  font-weight: ${({theme}) => theme.v2.typography.bodyText1.weight.default};
  font-size: ${({theme}) => theme.v2.typography.sizing.m.lg};
`;

const PercentText = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 14px;
`;

const ValueText = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({selected, theme}) =>
    selected ? theme.v2.color.base.grey["50"] : theme.v2.color.base.grey["600"]};
`;

export default OrderTipField;
